<template>
<div class="chapter">
<div class="inner_page">
<h1>Dedication</h1>
<p class="sectiontop">To Lee, the wife and mother who had the best years of her life stolen from her—and us.</p>
<p>To Patricia, who came into our lives and brought my family love they had lost, and joy newly found.</p>
<p>To Kimberley, Kevin, Jay, and Brendan of whom Dad is most proud.</p>
<p>To Patricia’s children Celeste and John who joined our family and welcomed us into theirs.</p>
<p>To our collective grandchildren who made our Sun Valley Christmases special, and brighten every day we are together.</p>
<p>To my sisters: Cindy, like Lee taken too soon, Mary Jo whose myriad interests and accomplishments are inspiring and Kathleen whose zest for life is contagious.</p>
<p>To my late cousin Pat, who served as the brother I never had, and as an uncle to my children who adored him.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?6ef690c8